import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import "../account/account.scss";


const Account = ({ handleClick }) => {

    const { logout, user } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
    };

    const handleNavigation = (path) => {
        handleClick?.(); // Popup schließen
        navigate(path);
    };

    return (
        <div className="account">
            <div className="user">
                <div className="userProfile">
                    <span>{user?.username?.[0]}</span>
                </div>
                <div className="info">
                    <span className="username">{user?.name} {user?.surname}</span>
                    <span className="email">{user?.email}</span>
                </div>
            </div>
            <hr />
            <div className="links">
                <button className="solid" onClick={() => handleNavigation("/settings")} >Einstellungen</button>
                <button className="secondary" onClick={handleLogout}>Abmelden</button>
            </div>
        </div>
    );
};

export default Account;